import { Layout, Table, Typography, Col } from "antd";
import React, { forwardRef, useCallback, useImperativeHandle, useState } from "react";
import axios from "api/axios";
import { useDpatIndicatorDataSource } from "hooks/useDpatIndicatorDataSource";
import DpatSubIndicatorSection from "../setup/DpatSubIndicatorSection";
import DpatIndicatorCmsIntro from "../setup/DpatIndicatorCmsIntro";
import MaxScoreDisplay from "../setup/MaxScoreDisplay";
import ActualScoreDisplay from "../setup/ActualScoreDisplay";
import IndicatorScoreSection from "../setup/IndicatorScoreSection";
import Comment from "components/Comments";

const AgricultureSupport = forwardRef(({
  year,
  districtId,
  hideComment,
  savedAssessmentData,
  assessmentStartLoading,
  isAssessmentStarted,
}, ref) => {
  const { Header, Content } = Layout;
  const { Title, Text } = Typography;

  const [agricultureSupport, setAgricultureSupport] = useState([]);
  const [score, setScore] = useState(0);
  const [maxScore, setMaxScore] = useState(1);

  const DPAT_SLUG = "pi4.0-4.3";

  useImperativeHandle(ref, () => ({
    getData: () => ({
      indicator: "PI4",
      area: "Access to Social Services",
      maxScore,
      agricultureSupport,
      score
    }),
  }));

  const agricultureSupportColumns = [
    { title: "No. of AEAs", dataIndex: "noOfAEAs", key: "noOfAEAs" },
    { title: "No of Operational Areas", dataIndex: "noOfoperational", key: "noOfoperational" },
    { title: "Data on mapping of AEAs to operational areas", dataIndex: "mapping", key: "mapping" }
  ];

  const loadFromDhis2 = useCallback(() => {
    axios
      .get(`/tracker/trackedEntities?orgUnit=${districtId}&program=zordSafiO6O&startDate=${year}-01-01&endDate=${year}-12-31`)
      .then(result => {
        if (result.data.instances.length > 0) {
          axios
            .get(`/tracker/events?program=zordSafiO6O&orgUnit=${districtId}&startDate=${year}-01-01&endDate=${year}-12-31`)
            .then(resp => {
              const agricultures = result.data.instances;
              setAgricultureSupport([{
                noOfAEAs: agricultures.length,
                noOfoperational: agricultures.length,
                mapping: "1:1"
              }]);

              if (agricultures.length > 0) {
                setScore(1)
              }
            })
            .catch(err => console.log(err))
        }
      })
      .catch(err => console.log(err))
  }, [districtId, year]);

  useDpatIndicatorDataSource({
    isAssessmentStarted,
    savedAssessmentData,
    assessmentStartLoading,
    loadFromDhis2,
    applySnapshot: (snap) => {
      if (snap.agricultureSupport) setAgricultureSupport(snap.agricultureSupport);
      if (snap.score != null) setScore(snap.score);
      if (snap.maxScore != null) setMaxScore(snap.maxScore);
    },
    deps: [year, districtId, loadFromDhis2],
  });

  return (
    <Comment
      data={agricultureSupport}
      year={year}
      districtId={districtId}
      tableCommentedId={`pi4.0-4.3-${year}`}
      hideComment={hideComment}
    >
      {({ renderCommentFeedbackFooter }) => (
          <DpatSubIndicatorSection code={DPAT_SLUG}>
          <DpatIndicatorCmsIntro
            year={year}
            slug={DPAT_SLUG}
            mainTitleStyle={{ marginTop: "20px" }}
          />

          <IndicatorScoreSection>
            <MaxScoreDisplay score={maxScore} />
            <ActualScoreDisplay slug={DPAT_SLUG} label="PI 4.0-4.3 Actual Score" score={score} />
          </IndicatorScoreSection>

          <Title level={5} style={{ marginTop: "20px" }}>
            Evidence of AEAs and operational areas
          </Title>
          <Table
            columns={agricultureSupportColumns}
            dataSource={agricultureSupport || []}
            pagination={false} bordered />
            {!hideComment && renderCommentFeedbackFooter()}
          </DpatSubIndicatorSection>
      )}
    </Comment>
  );
})

export default AgricultureSupport;